export const ALLOW_TAGS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "strong",
  "em",
  "s",
  "ol",
  "li",
  "ul",
  "a",
  "br",
  "span",
  "u",
  "img",
];

export function stripTags(input: string, allowed = ALLOW_TAGS) {
  return input.replace(
    new RegExp(`\\s*<(?!/?\\b(${allowed.join("|")})\\b)[^>]+>\\s*`, "gmi"),
    "",
  );
}
